import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-tail",
  "use": "icon-tail-usage",
  "viewBox": "0 0 24 10",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 10\" id=\"icon-tail\"><path d=\"M12 10 .742.25h22.516L12 10Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol